<script type="text/javascript">
export default {
  name: 'ConsultantCard',

  props: {
    consultant: {
      type: Object,
      default: null,
    },
  },
}
</script>

<template>
  <div class="consultant-card-wrapper">
    <template v-if="consultant">
      <div class="consultant-content">
        <div class="consultant-hd">
          <div class="consultant-avatar">
            <img
              :class="['consultant-avatar-el']"
              :src="consultant.avatar">
          </div>
          <div class="consultant-intro">
            <div class="consultant-name-wrapper">
              <div class="consultant-name">
                {{ consultant.name }}
              </div>
              <div class="consultant-firm">
                @爱车的诺诺
              </div>
            </div>
            你好，我是来自爱车的诺诺的{{ consultant.name }}，添加我的企业微信与我联系吧。
            {{ customIntroContent }}
          </div>
        </div>
        <div class="consultant-bd">
          <div class="consultant-wework-qrcode-wrapper">
            <div class="consultant-wework__title">
              <van-icon
                :name="'qr'"
                :size="20"
                class="consultant-wewrok__icon" />
              微信咨询
            </div>
            <div class="consultant-wework-qrcode-intro">
              <div class="bold">长按识别二维码</div>
              <div class="text">添加我的企业微信</div>
            </div>
            <div class="consultant-wework-qrcode">
              <img
                class="consultant-wework-qrcode-el"
                :src="consultant.qr_code">
            </div>
          </div>
        </div>
        <div class="consultant-ft" />
      </div>
      <div class="logo">
        <div class="logo-el" />
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.consultant-card-wrapper {
  width: 100%;
  background: var(--background);
  min-height: 50px;
  padding: 7px;
  box-sizing: border-box;
  font-size: 1rem;
}

.consultant-content {
  background: var(--background);
  border-radius: 10px;
  padding: 20px 20px;
  box-sizing: border-box;
  box-shadow: 0px 0px 2px 0px rgba(111,111,111,.1);
  margin-bottom: 10px;
}

.consultant-hd {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-bottom: 10px;
}

.consultant-avatar {
  margin-right: 10px;
}

.consultant-avatar-el {
  width: 70px;
  height: 70px;
  border-radius: 6rpx;
  box-sizing: border-box;
}

.consultant-name-wrapper {
  display: flex;
  flex-flow: row;
  align-items: baseline;
}

.consultant-name {
  color: var(--black-primary);
  margin-bottom: 2px;
  font-size: 1.125rem;
  font-weight: bold;
  margin-right: 5px;
}

.consultant-firm {
  color: #ff8214;
  margin-bottom: 5rpx;
  font-size: .85rem;
}

.consultant-intro {
  width: 100%;
  font-size: .9rem;
  box-sizing: border-box;
}

.consultant-bd {}

.consultant-wework-qrcode-wrapper {
  box-sizing: border-box;
  padding: 25px;
  box-sizing: border-box;
  background: #eaeaea;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  border-radius: 10px;
}

.consultant-wework-qrcode-intro {
  color: #757a80;
  font-size: 12px;
  text-align: center;
  margin-bottom: 10px;
  display: flex;
}

.consultant-wework-qrcode-intro .bold {
  font-weight: bold;
  margin-right: 5px;
}

.consultant-wework-qrcode-el {
  width: 200px;
  height: 200px;
}

.consultant-ft {
  display: flex;
}

.logo {
  width: 100%;
  display: flex;
}

.logo-el {
  margin: auto;
  width: 100px;
  height: 30px;
  background: transparent url(https://static.nuonuo.com.cn/zycmp/logo.png) center no-repeat;
  background-size: contain;
}

.consultant-wework__title {
  display: flex;
  align-items: center;
  margin-bottom: 2px;
}

.consultant-wewrok__icon {
  margin-right: 5px;
}

@media (min-width: 640px) {
  .consultant-avatar-el {
    width: 100px;
    height: 100px;
  }

  .consultant-wework-qrcode-el {
    width: 300px;
    height: 300px;
  }

  .logo-el {
    width: 150px;
  }
}

@media (prefers-color-scheme: dark) {
  .consultant-card-wrapper {
    background: #1A1A1A;
  }

  .consultant-wework-qrcode-wrapper {
    background: var(--background)
  }

  .logo-el {
    margin: auto;
    width: 100px;
    height: 30px;
    background: transparent url(https://static.nuonuo.com.cn/zycmp/logo-white-20241206.png) center no-repeat;
    background-size: contain;
  }
}
</style>
